import React, { useContext, useEffect, useState } from 'react'
import { Select, Spin, App, SelectProps } from "antd";
import { API, Enum } from "../../../resources/constants"
import language from "../../../resources/languages/fa_IR"

// Contexts
import AxiosContext from "../../../contexts/axios";

// Interfaces
import { AxiosError } from "../../../interfaces/axios"
import { AntTableParams } from "../../../interfaces/ant"
import type { TablePaginationConfig } from 'antd/es/table'

const { Pages: { UserManagement: { User: UserLanguage } }, Share, Validation, Message: MessageLanguage } = language
const { USER_MANAGEMENT_ROLE_ALL, USER_MANAGEMENT_USER_ROLE_ALL, USER_MANAGEMENT_USER_ROLE_UPDATE } = API
const { Message } = Enum

interface PermissionType {
    id: string,
    name: string,
    caption: string,
}
interface RoleType {
    id: string,
    name: string,
    caption: string,
    permissions: PermissionType[],
}

export default function AddRole(props: { Form: any, form: any, record: { id: string }|null, getUsers: (params: AntTableParams) => void, pagination: TablePaginationConfig, sort: string|false|null|undefined }) {
    const { Form, form, record, getUsers, pagination, sort } = props

    const { axios } = useContext(AxiosContext)
    const [roles, setRoles] = useState<SelectProps[]>([]);
    const [loadingRecord, setLoadingRecord] = useState<boolean>(true);
    const { message } = App.useApp();

    useEffect(() => {
        form.resetFields()
        initialAPI().then(response => response)
    }, []);

    const initialAPI = async () => {
        setLoadingRecord(true)
        await getRoles()
        record && await getUserRoles(record?.id)
        setLoadingRecord(false)
    }

    const getRoles = async () => axios.post(USER_MANAGEMENT_ROLE_ALL).then((response: { data: RoleType[] }) => {
        const { data: roles } = response
        setRoles(roles.map(({ id, caption}) => ({ label: caption, value: id })))
    }).catch((error: AxiosError) => {
        const { response: { data } } = error;
        // @ts-ignore
        message.error(MessageLanguage[data.message]).then(response => response )
    })

    const getUserRoles = async (id: string) => axios.post(USER_MANAGEMENT_USER_ROLE_ALL + id).then((response: { data: RoleType[] }) => {
        const { data: roles } = response
        form.setFieldValue('roles', roles.map(({ id }) => id))
    }).catch((error: AxiosError) => {
        const { response: { data } } = error;
        // @ts-ignore
        message.error(MessageLanguage[data.message]).then(response => response )
    })

    const onFinish = ((values: {}) => {
        setLoadingRecord(true)
        axios.patch(USER_MANAGEMENT_USER_ROLE_UPDATE + record?.id, values).then((response: {}) => {
            message.success(MessageLanguage[Message.UPDATE_RECORD]).then(response => response)
            setLoadingRecord(false)
            const { current, pageSize } = pagination
            getUsers({ page: current, limit: pageSize, sort })
        }).catch((error: AxiosError) => {
            const { response: { data } } = error;
            // @ts-ignore
            message.error(MessageLanguage[data.message]).then(response => response)
            setLoadingRecord(false)
        })
    })


    return (
        <Spin spinning={loadingRecord} tip={Share.loading} size="large">
            <Form form={form} name="add-role" onFinish={onFinish} style={{ margin: '25px 0 10px 0'}}>
                <Form.Item
                    label={UserLanguage.roles}
                    name="roles"
                    hasFeedback
                >
                    <Select
                        showSearch
                        allowClear
                        mode="multiple"
                        optionFilterProp="label"
                        placeholder={Share.pleaseSelectedRecords}
                        options={roles}
                    />
                </Form.Item>
        </Form>
        </Spin>
    )
}
